import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Navbar.css';

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAdmin, hasPermission, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className="navbar">
      <h1 onClick={() => navigate('/dashboard')} style={{cursor: 'pointer'}}>
        Ekol Tabela ERP
      </h1>
      
      <div className="nav-links">
        {/* Dashboard - view_dashboard izni */}
        {hasPermission('view_dashboard') && (
          <button onClick={() => navigate('/dashboard')} className={isActive('/dashboard')}>
            Dashboard
          </button>
        )}
        
        {/* Siparişler - view_orders izni */}
        {hasPermission('view_orders') && (
          <button onClick={() => navigate('/orders')} className={isActive('/orders')}>
            Siparişler
          </button>
        )}
        
        {/* Müşteriler - view_customers izni */}
        {hasPermission('view_customers') && (
          <button onClick={() => navigate('/customers')} className={isActive('/customers')}>
            Müşteriler
          </button>
        )}
        
        {/* Çalışanlar - view_employees izni */}
        {hasPermission('view_employees') && (
          <button onClick={() => navigate('/employees')} className={isActive('/employees')}>
            Çalışanlar
          </button>
        )}
        
        {/* Araçlar - view_vehicles izni */}
        {hasPermission('view_vehicles') && (
          <button onClick={() => navigate('/vehicles')} className={isActive('/vehicles')}>
            Araçlar
          </button>
        )}
        
        {/* Raporlar - view_reports izni */}
        {hasPermission('view_reports') && (
          <button onClick={() => navigate('/reports')} className={isActive('/reports')}>
            Raporlar
          </button>
        )}
        
        {/* Finans - view_finance izni */}
        {hasPermission('view_finance') && (
          <button onClick={() => navigate('/finance')} className={isActive('/finance')}>
            Finans
          </button>
        )}

        {/* Admin Paneli - Sadece admin */}
        {isAdmin && (
          <button onClick={() => navigate('/admin')} className={isActive('/admin')}>
            Admin
          </button>
        )}
        
        <button onClick={handleLogout} className="logout-btn">
          Çıkış
        </button>
      </div>

      {/* Kullanıcı bilgisi */}
      {user && (
        <div className="nav-user-info">
          <span className="nav-user-name">{user.username}</span>
          {isAdmin && <span className="nav-admin-badge">Admin</span>}
          {!isAdmin && user.roles?.length > 0 && (
            <span className="nav-role-badge">{user.roles[0]}</span>
          )}
        </div>
      )}
    </nav>
  );
}

export default Navbar;